import React, { useState } from "react";

const PaymentForm = ({ formData, onChange, onSubmit }) => {
  const [charges, setCharges] = useState({
    regular: 80,
    vanguard: 175,
    standard: 205,
    premium: 250,
    donor: 850,
  });
  console.log(setCharges);
  return (
    <form onSubmit={onSubmit} className="form__wrapper">
      <div className="form__wrapper--container">
        <div className="form__wrapper--group">
          <label htmlFor="name">Full Name:</label>
          <input
            type="text"
            id="name"
            name="Name"
            value={formData.Name}
            onChange={onChange}
            required
          />
        </div>

        <div className="form__wrapper--group">
          <label htmlFor="email">Email Address:</label>
          <input
            type="email"
            id="email"
            name="Email"
            value={formData.Email}
            onChange={onChange}
            required
          />
        </div>

        <div className="form__wrapper--group">
          <label htmlFor="phone">Phone Number:</label>
          <input
            type="tel"
            id="phone"
            name="Phone"
            value={formData.Phone}
            onChange={onChange}
            required
          />
        </div>

        <div className="form__wrapper--group">
          <label htmlFor="ticketCategory">Ticket Category:</label>
          <select
            id="ticketCategory"
            name="TicketCategory"
            value={formData.TicketCategory}
            onChange={onChange}
            required
          >
            <option value="">Which Ticket Category would like to buy?</option>
            <option value="regular">Regular</option>
            <option value="vanguard">Vanguard</option>
            <option value="standard">Standard</option>
            <option value="premium">Premium</option>
            <option value="donor">Donor</option>
          </select>
        </div>

        <div className="form__wrapper--group">
          <label htmlFor="amount">
            Amount:
            <span className="charges">
              {formData.TicketCategory && (
                <p>Charges: ₦{charges[formData.TicketCategory]}</p>
              )}
            </span>
          </label>
          <input
            type="number"
            id="amount"
            name="Amount"
            value={formData.Amount || 0}
            onChange={onChange}
            readOnly
            className="readonly-input"
          />
        </div>

        <div className="form__wrapper--group">
          <label htmlFor="quantity">Quantity:</label>
          <select
            id="quantity"
            name="Quantity"
            value={formData.Quantity}
            onChange={onChange}
            required
          >
            <option value="">How many tickets would you like to get?</option>
            {Array.from({ length: 10 }, (_, index) => (
              <option key={index + 1} value={index + 1}>
                {index + 1}
              </option>
            ))}
          </select>
        </div>

        <button type="submit" className="form__wrapper--btn">
          <span>Buy Ticket</span>
        </button>
      </div>
    </form>
  );
};

export default PaymentForm;
